export default "__VITE_ASSET__DgC0TABp__"